(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fv-notes-filter')) {
    customElements.define('fv-notes-filter', class extends HTMLElement {
      connectedCallback() {
        this.search = this.querySelector('.fv-notes-filter__input');
        if (!this.search) return;
        this.onInput = (event) => {
          if (event.target !== this.search) return;
          event.stopPropagation();
          this.filterNotes();
        };
        this.onKeydown = (event) => {
          if (event.target === this.search && event.key === 'Enter') event.preventDefault();
        };
        this.addEventListener('input', this.onInput);
        this.addEventListener('keydown', this.onKeydown);
        this.filterNotes();
      }
      disconnectedCallback() {
        this.removeEventListener('input', this.onInput);
        this.removeEventListener('keydown', this.onKeydown);
      }
      filterNotes() {
        const query = this.search.value.trim().toLocaleLowerCase();
        let matches = 0;
        this.querySelectorAll('li').forEach((row) => {
          const input = row.querySelector('input[type="checkbox"]');
          const label = row.querySelector('.facet-checkbox__text-label');
          const match = !query || (label && label.textContent.toLocaleLowerCase().includes(query));
          row.hidden = !match && !(input && input.checked);
          if (match) matches += 1;
        });
        this.querySelector('.fv-notes-filter__empty').hidden = matches > 0;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fv-restock"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('fv-restock')){
  customElements.define('fv-restock',class extends HTMLElement{
    connectedCallback(){
      this.variants=JSON.parse(this.querySelector('script').textContent);
      this.signup=this.querySelector('form');this.status=this.querySelector('[data-restock-status]');
      this.root=this.closest('product-info')||this.parentElement;
      this.sync=()=>{
        const field=document.getElementById(this.dataset.formId)?.querySelector('input[name="id"]');
        const variant=this.variants.find(v=>String(v.id)===field?.value);
        if(this.current===variant?.id)return;
        this.current=variant?.id;this.hidden=!variant||variant.available;
        this.querySelector('[data-restock-variant]').textContent=variant?.title||'';
        this.status.textContent='';this.signup.elements.consent.checked=false;
      };
      this.observer=new MutationObserver(this.sync);this.observer.observe(this.root,{subtree:true,childList:true,attributes:true,attributeFilter:['value']});
      this.onChange=()=>setTimeout(this.sync,0);this.root.addEventListener('change',this.onChange);this.sync();
      this.signup.onsubmit=async event=>{
        event.preventDefault();if(this.busy||!this.signup.reportValidity())return;
        this.sync();const variant=this.variants.find(v=>v.id===this.current);if(!variant||variant.available)return;
        this.busy=true;const submit=this.signup.querySelector('button');submit.disabled=true;
        this.status.textContent=this.dataset.saving;
        try{
          const response=await fetch(this.dataset.endpoint,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({email:this.signup.elements.email.value,consent:this.signup.elements.consent.checked,variant:String(variant.id),product:this.dataset.productId})});
          const result=await response.json();if(!response.ok||!result.ok)throw Error(result.error||this.dataset.failure);
          this.status.textContent=result.message+' ('+variant.title+')';this.signup.elements.email.value='';this.signup.elements.consent.checked=false;
        }catch(error){this.status.textContent=error.message||this.dataset.failure;}
        finally{this.busy=false;submit.disabled=false;}
      };
    }
    disconnectedCallback(){this.observer?.disconnect();this.root?.removeEventListener('change',this.onChange);}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fv-sample-card"] && !Shopify.designMode) return;
  try {
    if (!window.fvSampleFormsReady) {
  window.fvSampleFormsReady = true;
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('.fv-sample-form')) return;
    event.preventDefault();
    if (window.fvSampleAdding) return;
    window.fvSampleAdding = true;
    const buttons = document.querySelectorAll('.fv-sample-form button');
    buttons.forEach(button => { button.disabled = true; });
    const feedback = form.closest('.fv-sample-body').querySelector('.fv-sample-feedback');
    const data = new FormData(form);
    data.set('sections', 'cart-icon-bubble');
    data.set('sections_url', window.location.pathname);
    try {
      const response = await fetch(form.action + '.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || feedback.dataset.error);
      feedback.textContent = feedback.dataset.success;
      const cart = document.querySelector('#cart-icon-bubble');
      if (cart && result.sections && result.sections['cart-icon-bubble']) {
        const html = new DOMParser().parseFromString(result.sections['cart-icon-bubble'], 'text/html');
        cart.innerHTML = html.querySelector('.shopify-section')?.innerHTML || result.sections['cart-icon-bubble'];
      }
    } catch (error) {
      feedback.textContent = error.message || feedback.dataset.error;
    } finally {
      buttons.forEach(button => { button.disabled = false; });
      window.fvSampleAdding = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fv-sticky-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fv-sticky-purchase')) {
    customElements.define('fv-sticky-purchase', class extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.action = this.querySelector('button');
        this.price = this.querySelector('.fv-sticky-purchase__price');
        this.info = document.getElementById('ProductInfo-' + this.sectionId);
        if (!this.info) return;
        this.schedule = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.sync();
          });
        };
        this.buy = () => {
          const original = document.getElementById('ProductSubmitButton-' + this.sectionId);
          if (original && !original.disabled && original.getAttribute('aria-disabled') !== 'true') original.click();
        };
        this.action.addEventListener('click', this.buy);
        window.addEventListener('scroll', this.schedule, { passive: true });
        window.addEventListener('resize', this.schedule);
        this.observer = new MutationObserver(this.schedule);
        this.observer.observe(this.info, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
        this.sync();
      }
      sync() {
        const original = document.getElementById('ProductSubmitButton-' + this.sectionId);
        if (!original) {
          this.classList.remove('is-visible');
          this.hidden = true;
          return;
        }
        const priceRoot = document.getElementById('price-' + this.sectionId);
        const activePrice = priceRoot?.querySelector('.price--on-sale .price-item--sale') || priceRoot?.querySelector('.price-item--regular');
        if (activePrice && this.price.textContent !== activePrice.textContent.trim()) this.price.textContent = activePrice.textContent.trim();
        const label = original.querySelector('span:not(.loading__spinner)')?.textContent.trim() || original.textContent.trim();
        if (this.action.textContent.trim() !== label) this.action.textContent = label;
        const disabled = original.disabled || original.getAttribute('aria-disabled') === 'true';
        if (this.action.disabled !== disabled) this.action.disabled = disabled;
        const show = window.matchMedia('(max-width: 749px)').matches && original.getBoundingClientRect().bottom <= 0;
        if (this.hidden === show) this.hidden = !show;
        if (this.classList.contains('is-visible') !== show) this.classList.toggle('is-visible', show);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        window.removeEventListener('scroll', this.schedule);
        window.removeEventListener('resize', this.schedule);
        this.action?.removeEventListener('click', this.buy);
        if (this.frame) cancelAnimationFrame(this.frame);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
